export enum QueryKey {
  BOX = 'box',
  BOX_DETAILS = 'boxDetails',
  CONTENT = 'content',
  CONTENTS = 'contents',
  CONTENT_DRAFT_MAP = 'contentDraftMap',
  CONTENT_FILE = 'contentFile',
  CONTENT_MODELS = 'contentModels',
  CONTENT_REVIEWS = 'contentReviews',
  CUSTOMER = 'customer',
  CUSTOMERS = 'customers',
  CUSTOMERS_SEARCH = 'customersSearch',
  CUSTOMER_PROFILE = 'customerProfile',
  CUSTOMER_PROFILES = 'customerProfiles',
  DYNAMIC_LINKS = 'dynamicLinks',
  EVENTS = 'events',
  GENERATE_USER_PASSWORD = 'generateUserPassword',
  HOLIDAY_TYPES = 'holidayTypes',
  ITEMS = 'items',
  NOTIFICATIONS = 'notifications',
  ORDER = 'order',
  ORDERS = 'orders',
  ORDER_GROUP = 'orderGroup',
  ORDER_GROUP_SELECTED = 'orderGroupSelected',
  ORDER_ITEMS = 'orderItems',
  ORDER_SELLER_PROFILE = 'orderSellerProfile',
  PROJECT = 'project',
  PROJECTS = 'projects',
  REQUESTS = 'requests',
  SELLERS = 'sellers',
  SUPPLIERS = 'suppliers',
  TRIPS = 'trips',
  USERS = 'users',
  ZOHO_DEALS = 'zohoDeals'
}
